const initSmoothScroll = (el) => {
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: el.offsetTop,
  });
};

export default initSmoothScroll;
